export default __webpack_public_path__ + "static/media/gold_seal.83b872e1.webp";